import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { englishMessages } from "@pactfront/content/english";

export const uiEnglishMessages = {
  ...englishMessages,
  "app.brand": "PACTFRONT",
  "landing.title": "Make your move. Reveal the world.",
  "landing.titleLineOne": "Make your move.",
  "landing.titleLineTwo": "Reveal the world.",
  "landing.description":
    "A fair, one-session geopolitical strategy game where every commander plans in secret—and every order resolves together.",
  "landing.duration":
    "Most matches take about 25–70 minutes, depending on the preset and how early commanders are Ready.",
  "landing.howItWorks": "How it works",
  "landing.chooseHow": "Choose how to play",
  "landing.seeReveal": "See the simultaneous reveal",
  "landing.previewAlt":
    "Pactfront match showing the political map of Europe, command HUD, cities, and units",
  "landing.previewCaption": "A real Pactfront command-table match in progress.",
  "landing.command.title": "Choose your command",
  "landing.command.training.title": "Guided training",
  "landing.command.training.description": "Learn the core loop in a focused 5–7 minute scenario.",
  "landing.command.training.action": "Start training",
  "landing.command.solo.title": "Play vs computers",
  "landing.command.solo.description": "Command a private match against computer rivals.",
  "landing.command.solo.action": "Start solo match",
  "landing.command.multiplayer.title": "Multiplayer room",
  "landing.command.multiplayer.description":
    "Create a room or join friends with a six-character code.",
  "landing.command.multiplayer.action": "Create or join",
  "landing.trainingUnavailable":
    "Guided training is being prepared. You can practice the current command loop against computers now.",
  "landing.practiceSolo": "Practice vs computers",
  "landing.reveal.title": "Plan in secret. Resolve together.",
  "landing.reveal.plan.title": "Plan",
  "landing.reveal.plan.description": "Commit hidden orders",
  "landing.reveal.ready.title": "Ready",
  "landing.reveal.ready.description": "Lock your command",
  "landing.reveal.reveal.title": "Reveal",
  "landing.reveal.reveal.description": "Watch every order resolve",
  "landing.fairPlay.title": "Fair play, by design.",
  "landing.fairPlay.description":
    "No pay-to-win power. Hidden information stays hidden. Every commander resolves on the same clock.",
  "landing.privacyChoices": "Privacy choices",
  "landing.closePrivacy": "Close privacy choices",
  "landing.name": "Commander name",
  "landing.namePlaceholder": "Your name",
  "landing.code": "Room code",
  "landing.codeOptional": "Room code (optional)",
  "landing.codePlaceholder": "ABC234",
  "landing.create": "Create room",
  "landing.join": "Join room",
  "analytics.title": "Help improve Pactfront",
  "analytics.description":
    "Share anonymous usage and performance events. We never collect names, lobby codes, hidden orders, or private intelligence. Raw events are deleted within 90 days.",
  "analytics.allow": "Allow anonymous analytics",
  "analytics.deny": "No thanks",
  "analytics.allowShort": "On",
  "analytics.denyShort": "Off",
  "analytics.statusAllowed": "Anonymous analytics allowed. You can change this anytime.",
  "analytics.statusDenied": "Anonymous analytics off. Playing remains fully available.",
  "analytics.statusUnset": "Analytics is off until you choose Allow.",
  "lobby.title": "Lobby {{code}}",
  "lobby.country": "Select a country",
  "lobby.power": "Starting power {{power}}/5",
  "lobby.powerShort": "Power",
  "lobby.countrySummary":
    "{{country}}, power {{power}} of 5, development {{development}}, population {{population}}, military {{military}}",
  "lobby.metric.development": "Total development",
  "lobby.metric.population": "Total population",
  "lobby.metric.military": "Starting military power",
  "lobby.taken": "Selected",
  "lobby.yours": "Your country",
  "lobby.ready": "Lobby ready",
  "lobby.unready": "Not ready",
  "lobby.start": "Start match",
  "lobby.waiting": "Waiting for every seat to select a country and confirm.",
  "lobby.mode": "Match mode",
  "lobby.mode.turnLimit": "Turn Limit · {{count}} turns",
  "lobby.mode.worldDomination": "World Domination · unlimited",
  "lobby.players": "Players",
  "lobby.host": "Host",
  "lobby.computer": "Computer {{count}}",
  "lobby.randomCountry": "Random country",
  "lobby.rerollComputers": "Reroll computer countries",
  "lobby.botNote": "Computer players attack and expand without alliances.",
  "match.turn": "Turn {{turn}}",
  "match.planning": "Planning",
  "match.finished": "Finished",
  "match.phase.planning": "Planning",
  "match.phase.locked": "Locked",
  "match.phase.resolving": "Resolving",
  "match.phase.playback": "Playback",
  "match.phase.finished": "Finished",
  "match.treasury": "Treasury {{treasury}}",
  "match.timer": "Time remaining {{time}}",
  "match.hud.more": "More",
  "match.hud.less": "Less",
  "match.lobbyCode": "Lobby {{code}}",
  "match.workspaces": "Command workspaces",
  "match.workspace.orders": "Orders",
  "match.workspace.diplomacy": "Diplomacy",
  "match.workspace.politics": "Politics",
  "match.workspace.leaderboard": "Leaderboard",
  "match.workspace.close": "Close workspace",
  "match.workspace.orderCount": "{{count}} private orders this turn",
  "match.inspector": "City command panel",
  "match.inspector.close": "Close city panel",
  "match.inspector.city": "City",
  "match.inspector.production": "Production",
  "match.inspector.diplomacy": "Diplomacy",
  "match.ordersHidden": "Orders are hidden until resolution",
  "match.earlyReady": "All players ready resolves early",
  "match.playback.routine": "{{count}} routine updates completed",
  "match.playback.resolving": "Resolving visible conflicts…",
  "match.playback.motionOn": "Animated resolution: on",
  "match.playback.motionOff": "Animated resolution: off",
  "match.playback.modeDetailed": "Resolution: step-by-step",
  "match.playback.modeFast": "Resolution: fast",
  "match.playback.settings": "Resolution and audio settings",
  "match.playback.musicOn": "Music: on",
  "match.playback.musicOff": "Music: off",
  "match.playback.effectsOn": "Effects: on",
  "match.playback.effectsOff": "Effects: off",
  "match.playback.motionFull": "Motion: on",
  "match.playback.motionReduced": "Motion: reduced",
  "match.playback.next": "Next beat",
  "match.activity.expand": "Show activity history",
  "match.activity.collapse": "Hide activity history",
  "match.activity.dismiss": "Dismiss activity",
  "match.activity.urgentCount": "{{count}} urgent activity updates",
  "match.activity.flag": "{{name}} flag",
  "match.activity.moved": "moved units {{origin}} → {{target}}",
  "match.activity.captured": "captured {{city}} from",
  "match.activity.battleDraw": "The battle at {{city}} ended without a winner.",
  "match.activity.battleWon": "won the battle at {{city}} against",
  "match.activity.meetingBattleDraw": "The meeting battle near {{city}} ended in a draw.",
  "match.activity.meetingBattleWon": "won the meeting battle near {{city}} against",
  "match.activity.produced": "produced {{count}} {{unit}} at {{city}}.",
  "match.activity.developed": "developed {{city}} to level {{value}}.",
  "match.activity.fortified": "fortified {{city}} to level {{value}}.",
  "match.activity.refunded":
    "received a refund at {{city}}: {{treasury}} Treasury, {{population}} Population.",
  "match.activity.income": "collected {{amount}} Treasury income.",
  "match.activity.eliminated": "was eliminated.",
  "match.activity.missionDraw": "The {{domain}} battle near {{city}} ended without a winner.",
  "match.activity.missionWon": "won the {{domain}} battle near {{city}}.",
  "match.activity.mission": "completed {{mission}} near {{city}} with {{count}} {{domain}}.",
  "match.activity.battleBreakdown": "Visible battle strength breakdown",
  "match.activity.role.attacker": "Attacker",
  "match.activity.role.defender": "Defender",
  "match.activity.committed": "Committed",
  "match.activity.remaining": "Remaining",
  "match.activity.losses": "Lost",
  "match.activity.visiblePower": "Power {{base}} × {{roll}} = {{final}}",
  "match.activity.fortressBonus": "Fortress +{{value}}%",
  "match.activity.retreated": "Retreated to {{city}}",
  "match.activity.surrendered": "Survivors surrendered",
  "match.activity.bombardmentHits": "Structural hits: {{count}}",
  "match.activity.blockadeApplied": "Blockade applied for this turn",
  "match.selectCity": "Select a city",
  "match.infantry": "Infantry {{count}}",
  "match.landUnits": "Infantry {{infantry}} · Armor {{armor}} · Air {{air}} · Navy {{navy}}",
  "match.unitTotals": "National unit totals",
  "match.nationalTotals": "National Treasury, Development, Population, and Fortress totals",
  "match.cityEconomy":
    "Development {{development}} · Population {{population}} · Fortress {{fortress}}",
  "match.metric.development": "Development",
  "match.metric.population": "Population",
  "match.metric.fortress": "Fortress",
  "match.metric.infantry": "Infantry",
  "match.metric.armor": "Armor",
  "match.metric.air": "Air",
  "match.metric.navy": "Navy",
  "match.capacity": "Capacity {{used}}/{{total}}",
  "match.income": "+{{income}} projected income",
  "match.strength": "Strength: {{band}}",
  "match.target": "Target city",
  "match.units": "Infantry to move",
  "match.infantryMove": "Infantry to move",
  "match.armorMove": "Armor to move",
  "match.via": "via {{city}}",
  "match.queueMove": "Queue move",
  "match.production": "Production",
  "match.count": "Count",
  "match.queueProduction": "Queue production",
  "match.production.decrease": "Decrease production",
  "match.production.increase": "Increase production",
  "match.production.add": "Add one {{unit}} to this turn's production order",
  "match.production.remove": "Remove one {{unit}} from this turn's production order",
  "match.queued": "{{count}} queued",
  "match.currentValue": "Current {{value}}",
  "match.cost.treasury": "Treasury",
  "match.cost.population": "Population",
  "match.develop": "Develop city",
  "match.fortify": "Build fortress",
  "match.preferRetreat": "Prefer retreat",
  "match.noRetreat": "No controlled adjacent city is available for retreat.",
  "match.dragHint":
    "Drag a unit to a province. Dashed teal borders are reachable; muted red borders are unavailable. Navy targets coastal provinces within 500 miles.",
  "match.notifications": "Activity",
  "match.constraint.control": "Only an exact, controlled city can receive this order.",
  "match.constraint.ready": "Unready your orders before making changes.",
  "match.constraint.once": "This city already has this upgrade queued for the turn.",
  "match.constraint.maxFortress": "Fortress is already at the maximum level.",
  "match.constraint.treasury": "Not enough uncommitted Treasury.",
  "match.constraint.population": "Not enough recruitable Population in this city.",
  "match.constraint.capacity": "Not enough national military capacity.",
  "match.constraint.coast": "Navy production requires a coastal city.",
  "match.unit.infantry": "Infantry",
  "match.unit.armor": "Armor",
  "match.unit.air": "Air",
  "match.unit.navy": "Navy",
  "match.mission.domainLabel": "Mission force",
  "match.mission.domain.air": "Air",
  "match.mission.domain.navy": "Navy",
  "match.mission.typeLabel": "Mission",
  "match.mission.type.support": "Land support",
  "match.mission.type.amphibious-support": "Amphibious support",
  "match.mission.type.bombard": "Bombard",
  "match.mission.type.blockade": "Blockade",
  "match.mission.type.rebase": "Rebase",
  "match.mission.target": "Mission target",
  "match.mission.queue": "Queue hidden mission",
  "match.order.produce": "{{city}} · produce {{count}} {{unit}}",
  "match.order.mission": "{{origin}} → {{target}} · {{count}} {{domain}} · {{mission}}",
  "match.order.develop": "{{city}} · develop",
  "match.order.fortify": "{{city}} · fortify",
  "match.order.retreat": "{{city}} · retreat to {{target}}",
  "match.occupation.integrated": "Fully integrated",
  "match.occupation.integrating": "50% occupation integration",
  "match.occupation.captured": "0% occupation integration",
  "match.ready": "Ready",
  "match.endTurn": "End turn",
  "match.unready": "Unready",
  "match.ownOrders": "Private orders",
  "match.noOrders": "No orders queued",
  "match.remove": "Remove",
  "match.moveConfirm.kicker": "Confirm movement",
  "match.moveConfirm.available": "At origin",
  "match.moveConfirm.assigned": "Moving",
  "match.moveConfirm.decrease": "Move one fewer unit",
  "match.moveConfirm.increase": "Move one more unit",
  "match.moveConfirm.cancel": "Cancel",
  "match.moveConfirm.confirm": "Add to orders",
  "match.moveConfirm.amphibiousReady": "Amphibious route · Navy support queued",
  "match.moveUnavailable.ready": "Cancel Ready before adding or changing orders.",
  "match.moveUnavailable.amphibiousSupport":
    "First queue a Navy Amphibious support mission to {{city}} for this turn.",
  "match.moveUnavailable.noRoute": "No valid land route connects these cities this turn.",
  "match.moveUnavailable.missionRange":
    "That city is outside this unit's mission range. Navy can target coastal provinces within 500 miles.",
  "match.moveUnavailable.navyCoast": "Navy missions require coastal origin and target cities.",
  "match.orderAdded": "Order added: {{origin}} → {{target}}",
  "match.orderFailed": "Order was not added. {{reason}}",
  "match.orderUnavailable": "No uncommitted {{unit}} remains in this city.",
  "match.players": "Seats",
  "match.countryControl.player": "Controlled by {{player}}",
  "match.countryControl.neutral": "Neutral country",
  "match.connected": "connected",
  "match.disconnected": "reconnecting",
  "match.event.reinforcement": "Reinforcement reached {{city}}.",
  "match.event.battle": "Battle resolved at {{city}}.",
  "match.event.capture": "{{city}} changed control.",
  "match.event.production": "Production completed at {{city}}.",
  "match.event.development": "Development completed at {{city}}.",
  "match.event.fortification": "Fortification completed at {{city}}.",
  "match.event.refund": "A canceled order at {{city}} was refunded.",
  "match.event.income": "Turn income was collected.",
  "match.event.elimination": "A country was eliminated.",
  "match.event.mission-battle": "Air or naval combat resolved near {{city}}.",
  "match.event.mission": "A surviving mission affected {{city}}.",
  "match.eliminated": "eliminated",
  "match.outcome.turn-limit": "Turn Limit complete",
  "match.outcome.world-domination": "World Domination",
  "match.outcome.winner": "{{country}} wins",
  "match.outcome.victoryPoints": "Victory points",
  "match.outcome.returnHome": "Return to main page",
  "match.attackPreview.title": "Attack preview",
  "match.attackPreview.range":
    "{{label}} · {{attackerMin}}–{{attackerMax}} vs {{defenderMin}}–{{defenderMax}}",
  "match.attackPreview.warning":
    "Current intelligence only. Hidden reinforcements, opposing movement, missions, and combat variance can change the result.",
  "match.attackPreview.favorable": "Favorable",
  "match.attackPreview.balanced": "Balanced",
  "match.attackPreview.risky": "Risky",
  "match.attackPreview.suicidal": "Suicidal",
  "match.politics.title": "Politics",
  "match.politics.none": "No eligible cards this turn",
  "match.politics.immediate": "Immediate",
  "match.politics.turns": "{{count}} turn",
  "match.politics.turns_other": "{{count}} turns",
  "match.politics.target": "Policy target",
  "match.politics.adopt": "Adopt",
  "match.politics.dismiss": "No decision",
  "match.politics.selected": "Selected",
  "match.politics.active": "Active policies",
  "match.politics.expires": "through turn {{turn}}",
  "match.diplomacy.title": "Diplomacy",
  "match.diplomacy.reputation": "Reputation {{value}}/100",
  "match.diplomacy.relation.peace": "Peace",
  "match.diplomacy.relation.war": "War",
  "match.diplomacy.relation.nap": "NAP",
  "match.diplomacy.relation.trade": "Trade",
  "match.diplomacy.relation.alliance": "Alliance",
  "match.diplomacy.proposeNap": "Propose NAP",
  "match.diplomacy.proposeTrade": "Propose Trade",
  "match.diplomacy.proposeAlliance": "Propose Alliance",
  "match.diplomacy.declareWar": "Declare War",
  "match.diplomacy.break": "Break agreements",
  "match.diplomacy.confirmWar":
    "This declaration breaks active agreements and reduces reputation. Continue?",
  "match.diplomacy.confirmBreak":
    "Breaking these agreements reduces reputation immediately. Continue?",
  "match.diplomacy.incoming": "Incoming proposals",
  "match.diplomacy.outgoing": "Outgoing",
  "match.diplomacy.accept": "Accept",
  "match.diplomacy.decline": "Decline",
  "match.notice.proposalSent": "{{agreement}} proposal sent to {{country}}.",
  "match.notice.warDeclared": "War declared on {{country}}.",
  "match.notice.agreementsBroken": "Agreements with {{country}} were broken.",
  "match.notice.proposalAccepted": "Diplomacy proposal accepted.",
  "match.notice.proposalDeclined": "Diplomacy proposal declined.",
  "match.leaderboard.title": "Leaderboard",
  "match.leaderboard.country": "Country",
  "match.leaderboard.development": "Development",
  "match.leaderboard.population": "Population",
  "match.leaderboard.military": "Military",
  "match.leaderboard.diplomacy": "Diplomacy",
  "match.leaderboard.reputation": "Reputation",
  "match.visibility.exact": "Exact intelligence",
  "match.visibility.band": "Estimated intelligence",
  "common.loading": "Connecting to the authoritative server…",
  "common.retry": "Retry",
  "common.dismiss": "Dismiss message",
  "common.reconnecting": "Connection lost. Reconnecting to the authoritative server…",
  "error.payload.invalid": "The request was rejected by schema validation.",
  "error.session.required": "Create or resume a guest session first.",
  "error.session.invalid": "The saved guest session is no longer valid.",
  "error.lobby.notFound": "That lobby was not found.",
  "error.lobby.alreadyJoined": "This guest is already in a lobby.",
  "error.lobby.full": "That lobby is full.",
  "error.country.invalid": "That country is not selectable.",
  "error.country.taken": "Another seat selected that country.",
  "error.country.required": "Select a country before becoming ready.",
  "error.lobby.hostRequired": "Only the host can start this lobby.",
  "error.lobby.notReady": "Every seat must select a country and confirm.",
  "error.match.notFound": "The match was not found.",
  "error.match.playerRequired": "This guest does not own a seat in the match.",
  "error.match.notPlanning": "Orders can only change during Planning.",
  "error.orders.unreadyFirst": "Unready before changing orders.",
  "error.orders.invalidPath": "Choose a controlled origin and a one-hop land target.",
  "error.orders.insufficientUnits": "The queued moves exceed the origin stack.",
  "error.orders.unitsRequired": "Move at least one land unit.",
  "error.orders.invalidRetreat": "Choose an adjacent controlled retreat city.",
  "error.orders.invalidCity": "Choose a controlled city.",
  "error.orders.insufficientPopulation": "The city cannot spend that much Population.",
  "error.orders.insufficientTreasury": "The queued actions exceed your Treasury.",
  "error.orders.insufficientCapacity": "The queued Armor exceeds national capacity.",
  "error.orders.oneDevelop": "Only one Development purchase is allowed per city and turn.",
  "error.orders.invalidFortress": "That city cannot add another Fortress level this turn.",
  "error.orders.invalidMission": "That mission is not valid for its force, range, or target.",
  "error.orders.navyRequiresCoast": "Navy can only be produced in a controlled coastal city.",
  "error.orders.warRequired": "Declare War before targeting a hostile country.",
  "error.diplomacy.invalidTarget": "Choose another active country.",
  "error.diplomacy.alreadyActive": "That agreement is already active.",
  "error.diplomacy.peaceRequired": "Peace is required for that agreement.",
  "error.diplomacy.responseRequired": "Only the receiving country can answer this proposal.",
  "error.diplomacy.alreadyAtWar": "The countries are already at war.",
  "error.diplomacy.confirmBetrayal": "Confirm the agreement breach first.",
  "error.diplomacy.agreementMissing": "There is no matching active agreement.",
  "error.politics.offerMissing": "No politics offer is available this turn.",
  "error.politics.cardInvalid": "That politics card is not in your offer.",
  "error.politics.targetInvalid": "Choose a legal policy target.",
  "error.network": "The server did not acknowledge the command.",
  "country.northreach": "Northreach",
  "country.ironvale": "Ironvale",
  "country.suncoast": "Suncoast",
  "city.northhaven": "Northhaven",
  "city.eastwatch": "Eastwatch",
  "city.irondale": "Irondale",
  "city.stonegate": "Stonegate",
  "city.goldmere": "Goldmere",
  "city.suncliff": "Suncliff",
  "difficulty.medium": "Medium",
} as const;

const resources = { en: { translation: uiEnglishMessages } } as const;

await i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
